import { Component, HostListener } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import * as _ from 'lodash';
import * as moment from 'moment';
import { SharedService } from 'app/shared/services/shared.service';
import { HttpService } from 'app/shared/services/http.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.scss'],
})
export class ActivityLogComponent {
  public data: Array<any>;
  public offset: number;
  public itemsPerPage: number;
  public users: Array<any>;
  public numOfUsersColors: number;
  public searchQuery: string;
  public searchMode: boolean;
  public pollTimeout: any;
  public isLoading: boolean;
  public noMoreRecords: boolean;
  public subscriptions: Array<any>;
  public lastDateTimeShown: string;

  constructor(
    public sharedService: SharedService,
    public httpService: HttpService,
    public dictionaryService: DictionaryService,
    public ga: GoogleAnalyticsService
  ) {
    this.data = [];
    this.offset = 1;
    this.lastDateTimeShown = '0';
    this.itemsPerPage = 50;
    this.users = [];
    this.numOfUsersColors = 3;
    this.searchQuery = '';
    this.searchMode = false;
    this.isLoading = false;
    this.noMoreRecords = false;
    this.subscriptions = [];
  }

  ngOnDestroy() {}

  ngOnInit() {
    this.initialize();
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'NETWORK_CHANGE') {
          this.clearAllAudit();
        } else if (response.type === 'ACTIVITY_LOG_SHOW') {
          this.getAllAudit();
        } else if (response.type === 'ACTIVITY_LOG_HIDE') {
          clearTimeout(this.pollTimeout);
        } else if (response.type === 'SUPPLY_SAVED_SUCCESSFULLY') {
          this.clearAllAudit();
          this.getAllAudit();
        }
      })
    );
  }

  initialize() {
    this.data = [];
    this.offset = 1;
    this.users = [];
    this.searchQuery = '';
    this.searchMode = false;
  }

  clearAllAudit() {
    this.lastDateTimeShown = '0';
    this.data = [];
  }

  getAllAudit() {
    let params: any;
    const startDate: Date = new Date();
    const endDate: Date = new Date();
    // Start and end date
    startDate.setMonth(startDate.getMonth() - 1);
    startDate.setDate(startDate.getDate() + 1);
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    // XHR parameters
    params = {
      startDate: moment(startDate).format('ddd MMM DD YYYY HH:mm:ss'),
      endDate: moment(endDate).format('ddd MMM DD YYYY HH:mm:ss'),
      limit: this.itemsPerPage,
    };
    if (this.lastDateTimeShown !== '0') {
      params['lastDateTime'] = this.lastDateTimeShown;
    }
    // Get the entries
    this.isLoading = true;
    this.subscriptions.push(
      this.httpService.post('audit/getAllAudit', params).subscribe((response: any) => {
        this.parseItems(response);
        this.isLoading = false;
        if (response.length < this.itemsPerPage) {
          this.noMoreRecords = true;
        }
      })
    );
  }

  parseItems(items: Array<any>) {
    let currItem: any;
    let username: string;
    let changedEntity: any;
    let changedDataOldValueArray: Array<any>;
    let changedDataNewValueArray: Array<any>;
    for (let i = 0; i < items.length; i++) {
      currItem = _.cloneDeep(items[i]);
      currItem.showMore = false;
      currItem.changedEntities = [];
      for (const entity in items[i].entities) {
        changedEntity = {
          entityId: entity,
          changedData: items[i].entities[entity].changed_data,
        };
        for (let j = 0; j < changedEntity.changedData.length; j++) {
          if (this.sharedService.isEmpty(changedEntity.changedData[j].changedDataOldValue)) {
            changedEntity.changedData[j].changedDataOldValue = [this.dictionaryService.get('EMPTY')];
          } else {
            //This is for displaying comma seperated values in one field.
            changedDataOldValueArray = changedEntity.changedData[j].changedDataOldValue.split(',');
            changedEntity.changedData[j].changedDataOldValue = changedDataOldValueArray;
          }
          if (this.sharedService.isEmpty(changedEntity.changedData[j].changedDataNewValue)) {
            changedEntity.changedData[j].changedDataNewValue = [this.dictionaryService.get('EMPTY')];
          } else {
            //This is for displaying comma seperated values in one field.
            changedDataNewValueArray = changedEntity.changedData[j].changedDataNewValue.split(',');
            changedEntity.changedData[j].changedDataNewValue = changedDataNewValueArray;
          }
        }
        currItem.changedEntities.push(changedEntity);
      }
      this.data.push(currItem);
      // updating last "lastDateTimeShown" value for possible "More" request
      this.lastDateTimeShown =
        this.lastDateTimeShown > currItem.dateTime || this.lastDateTimeShown == '0'
          ? currItem.dateTime
          : this.lastDateTimeShown;
      username = !this.sharedService.isEmpty(items[i].name) ? items[i].name : '?';
      if (!_.find(this.users, { name: username })) {
        this.users.push({
          name: username,
          color: (this.users.length % this.numOfUsersColors) + 1,
          isUnknown: username === '?',
        });
      }
    }
  }

  searchAudit(loadMore: boolean = false) {
    let params: any;
    if (!this.sharedService.isEmpty(this.searchQuery)) {
      params = {
        search_phrase: this.searchQuery,
        limit: this.itemsPerPage,
      };
      if (!loadMore) {
        this.data = [];
        this.offset = 1;
        this.lastDateTimeShown = '0';
      }
      if (this.lastDateTimeShown !== '0') {
        params['lastDateTime'] = this.lastDateTimeShown;
      }
      this.searchMode = true;
      this.isLoading = true;
      this.httpService.post('audit/searchAudit', params).subscribe((response) => {
        this.parseItems(response);
        if (response.length < this.itemsPerPage) {
          this.noMoreRecords = true;
        }
        this.isLoading = false;
      });
    }
  }

  loadMore() {
    this.searchMode ? this.searchAudit(true) : this.getAllAudit();
  }

  clearSearch() {
    this.noMoreRecords = false;
    this.initialize();
    this.clearAllAudit();
    this.getAllAudit();
  }

  getUserName(username: string) {
    return !this.sharedService.isEmpty(username) ? username : '?';
  }

  getUserColor(username: string) {
    const classPrefix = 'itemUserOvalColor';
    return !this.sharedService.isEmpty(username) && _.find(this.users, { name: username })
      ? classPrefix + _.find(this.users, { name: username }).color
      : classPrefix + 'Unknown';
  }

  getItemEntityName(item: any) {
    const entities: any = item.entities;
    for (const property in entities) {
      if (entities[property]['log'] !== undefined) {
        return entities[property]['log'].entityName;
      }
    }
    return '';
  }

  onKeyDown($event: any) {
    if ($event.which === 13) {
      this.searchAudit();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick($event: any) {
    let clickedOnActivityLog = false;
    let clickedOnActivityLogButton = false;
    let index = 0;
    const path: any =
      $event.path || ($event.composedPath && $event.composedPath()) || this.sharedService.composedPath($event.target);
    /*
      Close activity log if needed
    */
    while (index < path.length && !clickedOnActivityLog && !clickedOnActivityLogButton) {
      clickedOnActivityLog = path[index].id === 'activityLog';
      clickedOnActivityLogButton = path[index].id === 'activityLogButton';
      if (!clickedOnActivityLog && !clickedOnActivityLogButton) {
        index++;
      }
    }
    if (!clickedOnActivityLogButton && !clickedOnActivityLog && this.sharedService.activityLogToggleStatus) {
      this.sharedService.toggleActivityLog();
    }
  }
}
